import { useEffect, useMemo, useState } from 'react'
import { Box, Dialog, IconButton, Typography } from '@mui/material'
import { Clock16Regular, Dismiss24Regular } from '@/components/Icon'
import SearchRow from './SearchRow'
import ThreadListRow from './ThreadListRow'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSectionAllThreadsDialog({
  open,
  onClose,
  threads = [],
  selectedThreadId,
  onSelectThread,
  onThreadMenuAction,
  onRenameThread,
}) {
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    if (!open) setSearchValue('')
  }, [open])

  const filteredThreads = useMemo(() => {
    const q = searchValue.trim().toLowerCase()
    if (!q) return threads
    return threads.filter((thread) => thread.title?.toLowerCase().includes(q))
  }, [threads, searchValue])

  const handleSelectThread = (thread) => {
    onSelectThread?.(thread)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      scroll="paper"
      aria-labelledby="threads-view-all-title"
      slotProps={{
        paper: { className: styles.dialogPaper, elevation: 0 },
      }}
    >
      <header className={styles.header}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', minWidth: 0 }}>
          <Box component="span" sx={{ display: 'inline-flex', color: 'var(--app-text-secondary)' }} aria-hidden>
            <Clock16Regular />
          </Box>
          <Typography id="threads-view-all-title" component="h2" className={styles.title}>
            Threads
          </Typography>
        </Box>
        <IconButton
          type="button"
          aria-label="Close threads"
          onClick={onClose}
          size="small"
          className={styles.closeButton}
        >
          <Dismiss24Regular className={styles.closeIcon} aria-hidden />
        </IconButton>
      </header>
      <div className={styles.body}>
        <SearchRow
          value={searchValue}
          onChange={setSearchValue}
          placeholder="Search threads"
        />
        {filteredThreads.length === 0 ? (
          <Typography component="p" className={styles.empty}>
            {threads.length === 0 ? 'Start conversation to see your History here' : 'No matching threads.'}
          </Typography>
        ) : (
          <Box component="ul" className={styles.list} aria-label="All threads">
            {filteredThreads.map((thread) => (
              <Box component="li" key={thread.id} className={styles.listItem}>
                <ThreadListRow
                  title={thread.title}
                  thread={thread}
                  menuSurface="threads"
                  active={thread.id === selectedThreadId}
                  onClick={() => handleSelectThread(thread)}
                  onThreadMenuAction={onThreadMenuAction}
                  onRenameThread={onRenameThread}
                />
              </Box>
            ))}
          </Box>
        )}
      </div>
    </Dialog>
  )
}
